<div class="messages-shell">
   <div class="messages-toolbar">
      <div>
         <div class="messages-title">Messages</div>
         <div class="messages-subtitle">Chats other users have looped you into</div>
      </div>

      <div class="messages-toolbar-actions">
         <div class="messages-filter-pills">
            <button
               type="button"
               [class.active]="filter === 'all'"
               (click)="setFilter('all')">
               All
               <span>{{ threads.length }}</span>
            </button>
            <button
               type="button"
               [class.active]="filter === 'unread'"
               (click)="setFilter('unread')">
               New Messages
               <span>{{ attentionCount }}</span>
            </button>
         </div>

         <div class="messages-search">
            <i class="fa fa-search"></i>
            <input
               [(ngModel)]="search"
               placeholder="Search messages..." />
         </div>
      </div>
   </div>

   <div
      class="messages-loading"
      *ngIf="loading">
      Loading messages…
   </div>

   <div
      class="messages-list"
      *ngIf="!loading">
      <div
         class="message-thread"
         *ngFor="let thread of visibleThreads"
         [class.expanded]="expandedThreadId === thread.id"
         [class.unread]="thread.isUnread">
         <div
            class="message-thread-summary"
            (click)="toggleThread(thread)">
            <span
               class="message-unread-dot"
               *ngIf="thread.isUnread"></span>

            <div
               class="message-avatar"
               [style.background]="getAvatarBg(thread.createdByName)"
               [style.color]="getAvatarColor(thread.createdByName)">
               {{ getInitials(thread.createdByName) }}
            </div>

            <div class="message-summary-main">
               <div class="message-summary-topline">
                  <span class="message-created-by">{{ thread.createdByName }}</span>
                  <span class="message-looped-text">looped you in</span>
                  <span
                     class="message-context-chip"
                     *ngIf="thread.contextLabel">
                     {{ thread.contextLabel }}
                  </span>
               </div>
               <div
                  class="message-summary-preview"
                  *ngIf="expandedThreadId !== thread.id">
                  {{ getSummary(thread) }}
               </div>
            </div>

            <div class="message-summary-actions">
               <span class="message-time">{{ formatThreadTime(thread.lastMessageOn) }}</span>

               <span
                  class="message-status needs-reply"
                  *ngIf="thread.isUnread">
                  <span class="message-status-dot"></span>
                  New message
               </span>

               <span
                  class="message-status replied"
                  *ngIf="!thread.isUnread">
                  <span class="message-status-dot"></span>
                  {{ getReplyBadge(thread) }}
               </span>

               <ng-container *ngIf="expandedThreadId !== thread.id && thread.isUnread">
                  <button
                     type="button"
                     class="message-quick-button"
                     (click)="quickReply(thread, 'Yes', $event)">
                     <i class="fa fa-check"></i>
                     Yes
                  </button>
                  <button
                     type="button"
                     class="message-quick-button"
                     (click)="quickReply(thread, 'No', $event)">
                     <i class="fa fa-times"></i>
                     No
                  </button>
                  <button
                     type="button"
                     class="message-quick-button"
                     (click)="openReply(thread, $event)">
                     Reply
                  </button>
               </ng-container>

               <i
                  class="fa fa-chevron-down message-chevron"
                  [class.open]="expandedThreadId === thread.id"></i>
            </div>
         </div>

         <div
            class="message-thread-expanded"
            *ngIf="expandedThreadId === thread.id">
            <div class="message-thread-meta">
               <span>
                  <i class="fa fa-users"></i>
                  {{ participantLine(thread) }}
               </span>
               <button
                  type="button"
                  class="message-context-link"
                  *ngIf="thread.contextId || thread.contextUrl"
                  (click)="openRelatedItem(thread, $event)">
                  {{ getOpenContextLabel(thread) }}
                  <i class="fa fa-chevron-right"></i>
               </button>
            </div>

            <div class="message-conversation">
               <div
                  class="message-bubble-row"
                  *ngFor="let message of thread.messages"
                  [class.mine]="message.isMine">
                  <div
                     class="message-avatar message-avatar-sm"
                     *ngIf="!message.isMine"
                     [style.background]="getAvatarBg(message.sentByName)"
                     [style.color]="getAvatarColor(message.sentByName)">
                     {{ getInitials(message.sentByName) }}
                  </div>
                  <div class="message-bubble-wrap">
                     <div
                        class="message-bubble"
                        [class.mine]="message.isMine">
                        {{ message.message }}
                     </div>
                     <div class="message-bubble-meta">{{ message.isMine ? "You" : message.sentByName }}, {{ formatMessageTime(message.sentOn) }}</div>
                  </div>
               </div>
            </div>

            <div class="message-reply-bar">
               <div class="message-quick-label">QUICK REPLY</div>
               <button
                  type="button"
                  class="message-quick-button"
                  (click)="quickReply(thread, 'Yes')">
                  <i class="fa fa-check"></i>
                  Yes
               </button>
               <button
                  type="button"
                  class="message-quick-button"
                  (click)="quickReply(thread, 'No')">
                  <i class="fa fa-times"></i>
                  No
               </button>
               <input
                  [(ngModel)]="replyText"
                  (keyup.enter)="sendTypedReply(thread)"
                  placeholder="Or write a message..." />
               <button
                  type="button"
                  class="message-send-button"
                  [disabled]="sending || !replyText.trim()"
                  (click)="sendTypedReply(thread)">
                  <i class="fa fa-paper-plane"></i>
                  Send
               </button>
            </div>
         </div>
      </div>

      <div
         class="messages-empty"
         *ngIf="visibleThreads.length === 0">
         No messages match this view.
      </div>
   </div>

   <div class="messages-footer">
      <span *ngIf="attentionCount > 0">{{ attentionCount }} new {{ attentionCount === 1 ? "message" : "messages" }}</span>
      <span *ngIf="attentionCount === 0">You're caught up.</span>
   </div>
</div>
